<script>
	import { onMount } from 'svelte';
	import Spinner from './spinner.svelte';
	import { RefreshIcon, SearchIcon} from '@rgossiaux/svelte-heroicons/solid';
	import "../public/global.css";
	import HistoricalReport from './HistoricalReport.svelte';
	import LoginPopup from './loginPopup.svelte';
	import Modal from './Modal.svelte';
	import Footer from './footer.svelte';
	import Login from './login.svelte';
	import * as urls from "../json/config.json";
	import InfiniteLoading from 'svelte-infinite-loading';
	import { debounce } from 'throttle-debounce';
	import Dropdown from './dropdown.svelte';
	import authenticate from "./authService";
	import { isAuthenticated, token } from "./store";
	import AcknowledgementPopup from './acknowledgementPopup.svelte';

	
	let showModal 	  = false;
	let showLogin     = false;
	let data 	  	  = [];
	let sortBy  	  = {col: "domain", direction: "ASC"};
	let search  	  = "";
	let filterOption  = undefined;
	let sort_list = ['network', 'domain', 'title', 'first_seen', 'http']
	let filter_list = ['TOR & I2P', "TOR Only", "I2P Only"]
	let query = "/results?sort_by=" + sortBy.col + "&sort_direction=" + sortBy.direction;
	let infiniteId = Symbol();
	let refresh = Symbol();
	var historicalData
	let next_page_endpoint  = undefined
	let showAck = true

	let promise       =  init()

	//Defining two variables for keeping track of the height and width for later use
	$: innerHeight 	  = 0;
	$: innerWidth     = 0;
	$: scrollY = 0;
	$: $token, (() => {
		refreshData()
	})();
	/**
	 * Reactive variable for sorting the data shown in the table based off of the
	 * column passed to it.
	 */
	$: sort = (event) => {
		let column = event.detail.option
		if (sortBy.col == column) {
			sortBy.direction = sortBy.direction == "ASC" ? "DESC" : "ASC"
		} else {
			sortBy.col = column
			sortBy.direction = "ASC"
		}
		data = []
		next_page_endpoint  = undefined
		query = "/results?sort_by=" + sortBy.col + "&sort_direction=" + sortBy.direction;

		if(search != ""){
			query = query + "&keyword=" + search
		}

		if(filterOption){
			query = query + filterOption
		}

		infiniteId = Symbol();
		promise = getData()
		document.body.scrollIntoView();
	}

	// /**
	// * Reactive variable for filtering the data based off of the string
	// * inputted by the user. 
	// */
	// $: if(search) {
	// 	promise = searchData()
	// }

	const searchData = debounce(
		1000,
		() => {
			data = []
			next_page_endpoint  = undefined
			query = "/results?sort_by=" + sortBy.col + "&sort_direction=" + sortBy.direction;

			if(search != ""){
				query = query + "&keyword=" + search
			}

			if(filterOption){
				query = query + filterOption
			}
			
			infiniteId = Symbol();
			promise = getData()
			document.body.scrollIntoView();
		},
		{ atBegin: false }
	);

	const filterData = (event) => {
		let option = event.detail.option
		data = []
		next_page_endpoint  = undefined
		query = "/results?sort_by=" + sortBy.col + "&sort_direction=" + sortBy.direction;

		if (option == 'TOR & I2P'){
			filterOption=undefined
		}else if (option == "TOR Only"){
			filterOption="&network=Tor"
			query = query + filterOption
		}else{
			filterOption="&network=I2P"
			query = query + filterOption
		}

		if(search != ""){
			query = query + "&keyword=" + search 
		}

		infiniteId = Symbol();
		promise = getData()
		document.body.scrollIntoView();
	}

	const refreshData = () => {
		showModal 	  = false;
		data 	  	  = [];
		sortBy  	  = {col: "domain", direction: "ASC"};
		search  	  = "";
		filterOption  = undefined;
		query = "/results?sort_by=" + sortBy.col + "&sort_direction=" + sortBy.direction;
		next_page_endpoint  = undefined
		infiniteId = Symbol();
		refresh = Symbol();
		promise = getData()
	}
	/**
	 * Handles opening the modal when a row on the table is selected.
	 * Takes one parameter, which is the domain of the selected row.
	 * 
	 * 
	 * @param selected_domain
	 */
	const openModal = async (selected_domain) => {
		await getHistoricalData(selected_domain);
		showModal  		= true;
		document.body.classList.add('modal-open');
	};

	/**
	 * Handles closing the modal and resetting any variables.
	 */
	const closeModal = () => {
		showModal = false;
		showLogin = false;
		document.body.classList.remove('modal-open');
	};
	
	async function init() {
		if(!$isAuthenticated){
			await authenticate(process.env.LOGINUSER, process.env.PASSWORD);
		}
		await getData();
	}
	
	/**
	 * Retreive current tor report
	 */
	async function getData() {
		try{
			if(query == null){
				return true;
			}

			if (next_page_endpoint == undefined){
				data=[]
			}

			let url = urls.base + query
			const res = await fetch(url, {
				cache: "no-store",
				method: 'GET',
				headers: {
					'Authorization': 'Bearer ' + $token
				},
			});
			if (res.ok) {
				let results = await res.json()
				let response = results.results
				next_page_endpoint  = results.next_page_endpoint
				query=results.next_page_endpoint
				data = await [...data, ...response];
			} else if (res.status === 401) {
				$isAuthenticated.set(false);
				await init()
			} else if (res.status === 429) {
				$isAuthenticated.set(false);
				await new Promise(r => setTimeout(r, 2000));
				await getData()
			} else {
				$isAuthenticated.set(false);
				throw new Error('Request failed:', response.status);
			}
		}
		catch(error){
			throw new Error(error);
		}
		return true;
	}

	async function getS3Report() {
		try{
			let url = urls.getS3report
			const res = await fetch(url, {
				cache: "no-store",
				method: 'GET',
				headers: {
					'Authorization': 'Bearer ' + token
				},
			});
			if (res.ok) {
				const blob = await res.blob();

				const a = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				a.href = url;
				a.download = "darkwebreport.zip";
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);

			} else if (res.status === 401) {
				await init()
			} else if (res.status === 429) {
				await new Promise(r => setTimeout(r, 2000));
				await getS3Report()
			} else {
				throw new Error('Request failed:', res.status);
			}
		}
		catch(error){
			throw new Error(error);
		}
		return true;
	}

	/**
	 * Retreive report for each domain
	 */
	 async function getHistoricalData(domain) {
		try{
			let url = urls.report + domain
			const res = await fetch(url, {
				cache: "no-store",
				method: 'GET',
				headers: {
					'Authorization': 'Bearer ' + $token
				},
			});

			if (res.ok) {
				historicalData = await res.json()
			} else if (res.status === 401) {
				await authenticate(process.env.LOGINUSER, process.env.PASSWORD)
				await getHistoricalData(domain)
			} else if (res.status === 429) {
				await new Promise(r => setTimeout(r, 2000));
				await getHistoricalData(domain)
			} else {
				throw new Error('Request failed:', response.status);
			}
		}
		catch(error){
			throw new Error(error);
		}
		return true;
	}

	function infiniteHandler({ detail: { loaded, complete }}) {
		let oldQuery = query
		getData().then(() => { 
			if (oldQuery != query && query != null && query != undefined) {
				loaded();
			} else {
				complete();
			}
		}).catch(()=>{
			complete();
		})
	}
	/**
	 * This function takes in the event of the action when it is called, if the event
	 * is equal to the Enter key, then it dispatches a new mouse click event on the target
	 * that called it
	 * 
	 * @param e
	 */
	let focusListener = (e) => {
		if (e.key === "Enter"){
			e.preventDefault();
			const event = new MouseEvent('click');
			e.target.dispatchEvent(event);
		}
		else if(e.key === " "){
			e.preventDefault();
			const event = new MouseEvent('click');
			e.target.dispatchEvent(event);
		}
	}

	const acknowledgment = () => {
        return `
        <div>
            <center>
                <p>
                    Proceed with Caution
                </p>
            </center>

            <p>
                By selecting "Continue" you acknowledge and understand that you may encounter content and activities that are malicious, illegal, or may otherwise pose a risk to your security and well-being.
                We strive to filter and remove questionable material; however, due to the vast and dynamic nature of content on the dark web, we cannot guarantee the complete absence of such material.
            </p>

            <p>
                Please proceed with caution and at your own risk. If you encounter child sexual abuse material (CSAM) please report this to the Canadian Centre for Child Protection (C3P) CyberTip line here or the US National Center 
                for Missing and Exploited Children CyberTip line  by clicking <a href="https://www.missingkids.org/gethelpnow/cybertipline" target="_blank">here</a>.
            </p>
        </div>
        `
    }

</script>

<svelte:window bind:innerHeight bind:innerWidth bind:scrollY/>
{#if showAck}
	<div class="overlay"><AcknowledgementPopup bind:showAck={showAck} message={acknowledgment()}/></div>
{/if}

<div class="wrapper">
	<div class="header">

		<div  class = login>
			<div class="title">
				<img class="logo" src="logo.png" alt="Hunchly logo">
				<span>Hunchly Dark Web Report</span>
			</div>

			<Login/>
		</div>
		
		
		{#if innerWidth <= 768}
			<div class="break">
				
			</div>
		{/if}

		<div class="inputs">

			<button class="header-inputs" on:click={refreshData}>
				<RefreshIcon color="#fff" height="25" width="25"/>
				{#if innerWidth > 768}
					Refresh
				{/if}
			</button>

			{#key refresh}
				<Dropdown menulist={sort_list} title="Sort" on:select={sort}/>
				<Dropdown menulist={filter_list} title="Filter" on:select={filterData}/>
			{/key}			

			<div class="header-inputs search-input">
				<input type="search" bind:value={search} placeholder="Search" on:input={searchData}/>
				<SearchIcon color="#fff" height="20" width="20"/>
			</div>
		</div>
	</div>

	{#await promise}
		<div class="spinner">
			<Spinner/>
		</div>
	{:then}

	<table>
		<thead>
			<th role="button" tabindex="0" class="network" on:keydown={focusListener} on:click={sort({"detail":{"option":'network'}})}>Type</th>
			<th role="button" tabindex="0" width="500px" class="domain" on:keydown={focusListener} on:click={sort({"detail":{"option":"domain"}})}>Domain &varr;</th>
			<th role="button" tabindex="0" widith="auto" on:keydown={focusListener} on:click={sort({"detail":{"option":'title'}})}>Most Recent Title &varr;</th>
			<th role="button" tabindex="0" width="200px" on:keydown={focusListener} on:click={sort({"detail":{"option":'first_seen'}})}>First Seen &varr;</th>
			<th role="button" tabindex="0" width="100px" class="http" on:keydown={focusListener} on:click={sort({"detail":{"option":'http'}})}>HTTP Status &varr;</th>
		</thead>

		<tbody>
			{#each data as row}
				{#if innerWidth <= 768}
					<tr tabindex="0" role="button" on:click|preventDefault={openModal(row['domain'])}>
						<td class="table-headings">Network: {row['network']}</td>
						<td class="table-headings">{row['domain']}</td>
						{#if row['title'] != "" && row['title'] != undefined}
							<td class="table-headings">{row['title']}</td>
						{/if}
						<td class="table-headings">First Seen: {row['first_seen']}</td>
						<td class="table-headings">HTTP Status: {row['http']}</td>
					</tr>
				{:else}
					<tr tabindex="0" role="button" on:keydown={focusListener} on:click|preventDefault={openModal(row.domain)}>
						<td class="table-headings">{row['network']}</td>
						<td class="table-headings domain">{row['domain']}</td>
						<td class="table-headings">{row['title']} </td>
						<td class="table-headings">{row['first_seen']}</td>
						<td class="table-headings http">{row['http']}</td>
					</tr>
				{/if}
			{/each}
		</tbody>
	</table>
	
	<InfiniteLoading on:infinite={infiniteHandler} distance={scrollY/2} identifier={infiniteId}>
		<span slot="noMore" style="color:whitesmoke">No more results returned</span>
		<span slot="noResults" style="color:whitesmoke">No more results returned</span>
	</InfiniteLoading>

	{:catch error}
		<p style="color: red">{error}</p>900px
	{/await}

	{#if showModal}
		<Modal on:close={closeModal}>
			<HistoricalReport data={historicalData} />
		</Modal>
	{/if}

	{#if showLogin}
		<Modal on:close={closeModal}>
			<LoginPopup />
		</Modal>
	{/if}
</div>

<Footer></Footer>
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<style>
	.overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(26, 4, 31, 0.5);
		z-index: 1000;
		backdrop-filter: blur(5px);;
	}
	.wrapper{
		min-height: 92vh;
		background: radial-gradient(
			ellipse at right,
			black 0%,  
			rgb(30, 3, 46) 100%,              /* black at the center */
			rgb(0, 0, 0) 0%,               /* black dominates in the center 70% */
			rgb(30, 3, 46) 100%,      /* green starts from 70% and becomes dominant at 80% */
			black 100%               /* back to black at the outer edges */
		);
  	}
	.logo{
		max-height: 50px;
		max-width: 50px;
		height: auto;
		width: auto;
		padding: 0 10px;
	}
	.header{
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		text-align: left;
		padding: 20px 10px 0 10px;
		position:sticky;
		top: 0;
		z-index: 20;
		background: radial-gradient(
			ellipse at right,
			black 0%,  
			rgb(30, 3, 46) 100%,              /* black at the center */
			rgb(0, 0, 0) 0%,               /* black dominates in the center 70% */
			rgb(30, 3, 46) 100%,      /* green starts from 70% and becomes dominant at 80% */
			black 100% 
		);
	}
	.title{
		width: auto;
		height: 53px;
		flex-grow: 0;
		display: flex;
		flex-direction: row;
		justify-content: left;
		align-items: flex-start;
		text-align: left;
		gap: 10px;
		padding: 10px 0;
		color: ghostwhite;
		font-size: 1.2rem;
		font-family: Noto Sans Regular;
		float:left
	}
	.inputs{
		width: auto;
		height: 45px;
		flex-grow: 0;
		display: flex;
		flex-direction: row;
		justify-content: right;
		margin-left: auto;
		align-items: flex-start;
		gap: 15px;
		padding: 15px;
	}
	.login{
		display:inline-block;
		width: 95vw;
	}

	.header-inputs{
		height: 45px;
		max-height: 45px;
		flex-grow: 0;
		font-size: 0.9rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 10px;
		padding: 10px 15px;
		border-style: solid;
		border-width: 3px;
		border-image-source: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		border-image-slice: 1;
		background-color: #1e1e1e;
		color: #fff;
		cursor: pointer;
		box-sizing: border-box;
	}
	.header-inputs:focus{
		border-color: orange;
	}
	input{
		background-color: #1e1e1e;
		border: 0;
		margin:0;
		padding: 0;
		max-width: 100px;
		height:30px;
		color: whitesmoke
	}
	::placeholder{
		color: #fff;
		opacity: 0.7;
	}
	:-ms-input-placeholder{
		color: #fff;
	}
	.table-headings{
		font-family: Noto Sans Regular;
		font-size: 0.9rem;
		line-height: normal;
		text-align: center;
		color: #fff;
		word-break: break-word;
	}
	.domain{
		font-family: 'Noto Sans Mono';
		font-stretch: semi-condensed;
	}
	.network{
		min-width: 35px;
		max-width: 35px;
		width: 35px;
	}
	.table-headings.domain {
		font-family: "Noto Sans Mono";
		font-size: 0.8rem;
		font-stretch: condensed;
	}

	table{
		border-collapse: collapse;
		margin: 0px auto;
		font-size: 0.9em;
		width: 95%;
	}
	thead th{
		color: #fff;
		cursor: pointer;
		position: sticky;
		top: 92px;
		z-index: 1;
    	background: #1f1f1f;
		box-shadow: 0 4px 4px 0 #000, inset 0 -2px #7a7b81;
	}
	th, td{
		padding: 10px;
	}
	table, th, td{
		border: solid 1px rgba(255, 255, 255, 0.2);
	}
	tbody tr{
		font-size: 0.9rem;
		font-family: Noto Sans Regular;
		cursor: pointer;
		overflow: -moz-hidden-unscrollable;
	}
	tbody tr:nth-of-type(odd){
		background-color: #232430;
	}
	tbody tr:hover{
		opacity: 0.5;
	}
	@media screen and (max-width: 768px){
		.spinner{
			margin-top: 40px;
		}
		.logo{
			padding-left: 5px;
			padding-right: 0;
		}
		.break{
			flex-basis: 100%;
			height: 10px;
		}
		.header{
			flex-direction: row;
			flex-wrap: wrap;
			padding:0;
			justify-content: center;
			align-items: center;
			gap: 10px;
			width: 100%;
			padding: 10px 0;
		}
		.title{
			height: auto;
			font-size: 1.2rem;
			line-height: normal;
			letter-spacing: 0.8px;
			display:flex;
			align-items:center;
			justify-content: center;
			padding: 5px;;
		}
		.inputs{
			justify-content: center;
			margin: 0;
			z-index: 1;
		}
		table{
			width: 100%;
			margin: 0 !important;
		}
		tr{
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			border-radius: 2px;
			border: solid 1px rgba(255, 255, 255, 0.2);
			background-color: rgba(156, 12, 207, 0.05);
			overflow: hidden;
			word-break: break-word;
		}
		thead th{
			display: none;
		}
		td{
			border: none;
			text-align: left !important;
			font-size: 2.5rem;
			letter-spacing: 0.75px;
		}
	}
	@media screen and (max-width: 480px){
		tbody tr{
			height: auto;
			padding: 0 !important;
		}
		thead th{
			display: none;
		}
	}
</style>